import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * The one table/section surface: the flat `rounded-lg border bg-card` shell
 * of the dashboard cards. Wrap a DataTable or section content in this
 * instead of re-typing the literal. Prefer DashboardCard when the section
 * has a title.
 */
export const TableCard = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("rounded-lg border border-border bg-card", className)}
    {...props}
  />
));
TableCard.displayName = "TableCard";
